import BaseEntry from './base-entry'

const NoIndexEntry = (props) => <BaseEntry noindex={true} nofollow={true} {...props} />

export default NoIndexEntry
